<a
  *ngIf="target$ | async as link"
  [finLink]="link.url"
  [external]="link.external"
  [ngClass]="colorClass || 'nordic-blue-900-text text-icon-primary'"
  class="block no-underline align-right font-body-1 bold-type pr-xxsmall-r underline-hover font-body-medium-bold"
  (beforeNavigation)="click.emit()"
>
  {{ teaserTitle$ | async }}
  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
</a>
